exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploading-image[data-v-3da14d47] {\n  display: -webkit-box;\n  display: flex;\n}\n.col-form-label[data-v-3da14d47] {\n  white-space: nowrap;\n}\n", ""]);

// exports
